<!-- 根据条件筛选产品 -->
<template>
    <div class="filter-product-container" ref="activity_scroll" @scroll="activityScroll">
        <!-- 顶部搜索组件 -->
        <roof-search @secondCategoryChange="secondCategoryChange"></roof-search>
        <!-- 商城 -->
        <product-content showFiltrate :applyFilterBtn="category_id == 106" :productList="productList" @attrFilterData="attrFilterData" ref="product_content"></product-content>
    </div>
</template>

<script>
import { getProductList, categoryInfo, getAllCategory } from '@/api/product'
import roofSearch from '@/components/roof-search'
import productContent from './components/product-content'
import { wxShare } from '@/libs/wxjssdk'
export default {
    components: {
        roofSearch,
        productContent
    },
    data () {
        return {
            title: '',
            category_id: '',
            productList: [
                {
                    title: '',
                    product: []
                }
            ],
            params: {}, // 请求的参数
            page: 1, // 当前页码
            pageSize: 10, // 一页显示10个
            last_page: 1, // 最后一页的页码
            shareDescText: '',
            shareTitle: ''
        }
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    created () {
        var query = this.$route.query
        this.category_id = query.category_id || ''
        var params = {
            parent_category_id: this.category_id
        }
        this.params = params
        this.getCategoryInfo()
        this.getProductListPort()
    },
    mounted () {
        this.$refs.product_content.getConditionPort({
            category_id: this.category_id
        })
    },
    methods: {
        sharePage () {
            const params = {
                title: `${this.shareTitle}`, // 分享标题
                desc: `${this.shareDescText} `, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            console.log(params)
            wxShare(params)
        },
        // 上拉触底
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 150 // 距离底部距离
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0
                    })
                    this.getProductListPort()
                }
            }
        },
        // 单击了分类
        secondCategoryChange () {
            this.$router.push('secondProduct')
        },
        // attr_id 改变( button单击确定按钮 )，重新获取数据
        attrFilterData (attrId) {
            // console.log(attrId, 66666)
            var params = {
                attr_id: attrId,
                parent_category_id: this.category_id
            }
            this.page = 1
            this.productList[0].product = []
            this.params = params
            this.getProductListPort()
            this.getAllCategoryPort()
        },
        /** 网络请求 **/
        // 根据类别获取产品数据
        getProductListPort () {
            var paramsData = {
                ...this.params,
                page: this.page,
                size: this.pageSize
            }
            getProductList(paramsData).then((res) => {
                if (res.errCode === 0) {
                    var data = res.data
                    this.last_page = data.last_page
                    // console.log(data)
                    var productList = this.productList[0].product
                    productList.push(...data.data)
                    this.getAllCategoryPort()
                    // var productList = [
                    //   {
                    //     title: this.title,
                    //     product: data.data
                    //   }
                    // ]
                    // this.productList = productList
                }
            })
        },
        // 获取类别详情
        getCategoryInfo () {
            var params = {
                category_id: this.category_id
            }
            categoryInfo(params).then((res) => {
                if (res.errCode === 0) {
                    var data = res.data
                    this.title = data.title || ''
                    this.productList[0].title = data.title || ''
                }
            })
        },
        //  获取所有分类
        getAllCategoryPort () {
            getAllCategory().then((res) => {
                this.shareTitle = ''
                this.shareDescText = ''
                const firstType = res.filter((item) => {
                    if (Number(item.id) === Number(this.params.parent_category_id)) {
                        this.shareTitle = item.title
                        return item
                    }
                })
                document.title = this.shareTitle || '产品筛选'
                if (firstType[0].children) {
                    firstType[0].children.forEach((item, index) => {
                        if (index === firstType[0].children.length - 1) {
                            this.shareDescText += `${item.title}`
                        } else {
                            this.shareDescText += `${item.title}、`
                        }
                    })
                }

                this.shareDescText.substring(0, this.shareDescText.length - 1)
                this.sharePage()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-product-container {
    background: #eeebf4;
    /*display: flex;*/
    /*flex-direction: column;*/
    height: 100vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}
</style>
